export default {
  directives: {
    'forlogin': {
      inserted: function (el, { value }, { context }) {
        const vm = context
        let target = el
        if (!['INPUT'].includes(el.nodeName)) {
          target = target.querySelector(`input`)
        }
        target.id = value
        const forDom = document.querySelector(`label[for='${value}']`)
        // 解决Chromium 初始化自动获取密码没有值问题 (-webkit-autofill)
        let count = 0
        const timer = setInterval(() => {
          count += 100
          if (count > 20 * 100) {
            clearInterval(timer)
          }
          const webkitContent = window.getComputedStyle(target).content
          if (webkitContent === '"autofill"' || vm.form[value]?.length) {
            clearInterval(timer)
            forDom.parentNode.style.cssText = 'top: -8px; font-size: 12px; left: 0; transition: none'
          }
        }, 100)
        // 事件委托
        target.addEventListener('focus', e => {
          forDom.parentNode.nextSibling.querySelector('.home-ant-form-item-children').style.cssText = 'border-bottom: 1px #077BFC solid'
          forDom.parentNode.style.cssText = 'top: -8px; font-size: 12px; left: 0'
          forDom.style.cssText = 'overflow: visible'
        })
        target.addEventListener('blur', e => {
          if (forDom?.parentNode?.nextSibling) forDom.parentNode.nextSibling.querySelector('.home-ant-form-item-children').style.cssText = ''
          setTimeout(() => {
            if (vm.form[value]?.length) return
            forDom && (forDom.parentNode.style.cssText = '')
            forDom.style.cssText = ''
          }, 120)
        })
        target.addEventListener('change', () => {
          vm.$nextTick(() => {
            forDom.parentNode.style.cssText = vm.form[value]?.length ? 'top: -8px; font-size: 12px; left: 0' : ''
          })
        })
      }
    }
  }
}
